import { NgClass } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    HostBinding,
    input,
} from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { IconComponent } from '@interacta-shared/ui-icons';
import { InteractaIcon } from '@interacta-shared/util';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'button[interacta-user-menu-button]',
    templateUrl: './user-menu-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconComponent, NgClass, MatRippleModule],
})
export class UserMenuButtonComponent {
    readonly icon = input<InteractaIcon>();
    readonly withArrow = input(false);
    readonly width = input<'content' | 'full'>('content');
    @HostBinding('disabled') disabled = false;
}
